import React from "react";
import StaffList from "./StaffList";
import StaffDetail from "./StaffDetail";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import StaffAdd from "./StaffAdd";

export default function Staff(props) {
  let contentComponent = <StaffList />;
  if (props.staffId)
    contentComponent = (
      <StaffDetail
        mode={props.mode}
        staffId={props.staffId}
        documentId={props.documentId}
      />
    );
  if (props.staffId === "add") contentComponent = <StaffAdd />;

  return (
    <>
      <CrumbsProvider title="Параметры" link="/reference/" />
      <CrumbsProvider title="Сотрудники" link="/staff/" />
      <div className="container">{contentComponent}</div>
    </>
  );
}
